import { CartItemInterface } from "../interfaces/cart";

interface Payload {
    name: string;
    price: number;
}

export type CartAction =
    | { type: "ADD_CART"; payload: Payload }
    | { type: "REMOVE_CART"; payload: Payload }
    | { type: "CLEAR_CART" };

interface CartState {
    items: Array<CartItemInterface>;
}

const initialState: CartState = {
    items: [],
};

const cart = (state = initialState, action: CartAction) => {
    switch (action.type) {
        case "ADD_CART":
            let items = [...state.items];
            items.push(action.payload);
            return { items };
        case "REMOVE_CART":
            return {
                items: state.items.filter(function (obj) {
                    return obj.name !== action.payload.name;
                }),
            };
        case "CLEAR_CART":
            return initialState;
        default:
            return state;
    }
};

export default cart;
